import React from 'react';
import * as S from './loading-screen.molecule.style';

export const LoadingScreen: React.FC = () => {
  return (
    <S.Container>
      <S.Spinner />
    </S.Container>
  );
};
